import { Grid, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

import { getCurveInfoGroup, graphType } from "../../../model/Common";

import PressManagementDialogFormRow from "./PressManagementDialogFormRow";

/**
 * PressManagementDialogFormAreaコンポーネント.
 *
 * @param {string} type グラフ種別
 * @return {object} コンポーネント
 */
function PressManagementDialogFormArea(props) {
  // 引数
  const {
    // グラフ種別
    type,
  } = props;

  let title;
  switch (type) {
    case graphType.lr:
      title = "左右方向";
      break;
    case graphType.fb:
      title = "前後方向";
      break;
    default:
      title = "-";
      break;
  }

  const info = getCurveInfoGroup(type);

  return (
    <Grid container item xs={6}>
      <Grid item xs={12}>
        <Typography variant="h6">{title}</Typography>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid container item xs={12} alignItems="center">
          <Grid item xs={3}>
            <Typography variant="h6">CSV情報</Typography>
          </Grid>
          <Grid item xs={9}>
            <Typography variant="h6">凡例名称</Typography>
          </Grid>
        </Grid>
        <PressManagementDialogFormRow info={info.load} />
        <PressManagementDialogFormRow info={info.curve1} />
        <PressManagementDialogFormRow info={info.curve2} />
        <PressManagementDialogFormRow info={info.curve3} />
        <PressManagementDialogFormRow info={info.curve4} />
        <PressManagementDialogFormRow info={info.curve5} />
      </Grid>
    </Grid>
  );
}

PressManagementDialogFormArea.propTypes = {
  type: PropTypes.string.isRequired,
};

export default PressManagementDialogFormArea;
